import Axios, { CancelTokenSource } from "axios";

import { API } from "utils/api-config";

import { defaultErrorResponse } from "api/defaults";

import { Features } from "store/environments/tenants/tenant-configurations/tenant-configurations-types";

export const loadFeatureConfigurations = async (
    envMoniker: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[Features | null, number]> => {
    if (!envMoniker || !tenantId) {
        return defaultErrorResponse;
    }
    const response = await API.get(
        `environments/${envMoniker}/tenants/${tenantId}/features/configurations`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const updateFeatureConfigurations = async (
    envMoniker: string,
    tenantId: string,
    featureConfigurations: Features
): Promise<[string | null, number]> => {
    if (!envMoniker || !tenantId) {
        return defaultErrorResponse;
    }
    const response = await API.put(
        `environments/${envMoniker}/tenants/${tenantId}/features/configurations`,
        featureConfigurations
    );

    return [null, response.status];
};

export const checkTenantDatabaseAlertRuleExistence = async (
    envMoniker: string,
    tenantMoniker: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[boolean | null, number]> => {
    if (!envMoniker || !tenantMoniker) {
        return defaultErrorResponse;
    }
    const response = await API.get(
        `environments/${envMoniker}/tenants/${tenantMoniker}/features/alert-rule-exists`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};
